import { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react'; // o cualquier ícono
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

type NavigationItem = {
  id: string;
  label: string;
  href: string;
};

export function LawyerHeaderMenu({ navigationItems }: { navigationItems: NavigationItem[] }) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={menuRef}>
        <Button
            variant="ghost"
            onClick={() => setOpen(!open)}
            className="flex items-center gap-1 text-neutral-600 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-neutral-100"
        >
            Para abogados
            {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </Button>

        {open && (
            <div className="absolute left-0 top-full mt-2 w-56 rounded-md border border-gray-200 bg-white shadow-lg z-50 dark:bg-neutral-900">
            <div className="flex flex-col">
                {navigationItems.map((item: any) => (
                    <button
                        key={item.id}
                        onClick={() => {
                            if (item.href === 'legalbot') {
                                window.open(`/${item.href}`, '_blank', 'noopener,noreferrer');
                            } else {
                                navigate(`/${item.href}`);
                            }
                            setOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left text-sm text-neutral-700 hover:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800"
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            </div>
        )}
        </div>
    );
}
